module.exports = __webpack_public_path__ + "img/home-map-location.26c4c9c6.jpg";